import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import React from 'react';

import ChartIcon from './ChartIcon';
import MenuItemContentWithIcon from '../../components/MenuItemContentWithIcon';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getUITA } from '../../utils/commonUtils';
import { CHART_TYPE_PICKER_TITLE } from '../constants/report-designer.constants';
import { CHART_TYPE_VALUES } from '../constants/report-designer.properties.constants';

const OPTIONS = CHART_TYPE_VALUES.map((v) => ({
  ...v,
  icon: <ChartIcon chartType={v.value} size={15} color="unset" />,
}));

const ChartTypePicker = ({ onChange }) => {
  const translateString = useTranslation();

  return (
    <Select
      size="small"
      fullWidth
      label={translateString(CHART_TYPE_PICKER_TITLE)}
      placeholder={translateString(CHART_TYPE_PICKER_TITLE)}
      onChange={(e) => onChange(e.target.value)}
      ui-ta={getUITA('ChartTypePicker')}
    >
      {OPTIONS.map(({ icon, label, value }) => (
        <MenuItem key={value} value={value}>
          <MenuItemContentWithIcon label={label} icon={icon} />
        </MenuItem>
      ))}
    </Select>
  );
};

export default ChartTypePicker;
